import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {communicationChannelAction} from "redux/actions";


export default function AddCommChannel(status) {

    const [channelsName, setChannelsName] = useState('');


    const {customers, userRole} = useSelector(state => ({
        customers: state.customers,
        userRole: state.userRole?.filter(role => role.module === "Customers")
    }));

    const dispatch = useDispatch();
    useEffect(() => {
        
    }, []);

    const addData = () =>{
        dispatch(communicationChannelAction.add({ name: channelsName}));
        setChannelsName('');
    } 

   
    return (
        <div>
            <h2>Add Communication Channel</h2>
            <form action="">
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="channels_name">Channels Name:</label>
                    <input type="text" className="form-control" id="channels_name" placeholder="Enter Channels Name" name="channels_name" onChange={e => setChannelsName(e.target.value)} value={channelsName}/>
                </div>
                <div className="form-group" style={{marginBottom:"15px",textAlign:"right"}}>
                    <button type="button" className="btn btn-primary" onClick={addData}>Submit</button>
                </div>
            </form>
        </div>
    );
}
